/**
 * Utility function to check if a clinic is on a free plan
 * @param {Object} clinicData - The clinic data object
 * @returns {boolean} - true if clinic is on free plan, false otherwise
 * 
 * Backend structure: clinicsubscription table
 * - clinic.clinic_subscription.plan (full object) - preferred
 * - clinic.clinic_subscription_plan (string) - fallback
 * - plan values: 'free' or 'paid' (lowercase)
 * - Defaults to 'free' if subscription is null
 */
export const isClinicOnFreePlan = (clinicData) => {
  if (!clinicData?.clinic) {
    return true; // Default to free if no clinic data
  }

  const clinic = clinicData.clinic;
  
  // Check new clinicsubscription table structure (backend provides both formats)
  // Method 1: Check full subscription object (preferred)
  const subscriptionPlan = clinic.clinic_subscription?.plan;
  
  // Method 2: Check plan string directly (fallback)
  const planString = clinic.clinic_subscription_plan;
  
  // Use whichever is available
  const plan = subscriptionPlan || planString;
  
  if (plan) {
    // Plan values are lowercase: 'free' or 'paid'
    return plan === 'free';
  }
  
  // Default to 'free' if subscription is null (old clinics or not migrated yet)
  return true;
};

